import React from "react";
import { Link } from "react-router-dom";
import styles from "./DiscoverNearbySection.module.css";
import { popularPlaces } from "../../Experiences/experiencesData";

const DiscoverNearbySection = () => {
  return (
    <section className={styles.section} aria-labelledby="discover-nearby-heading">
      <div className={styles.copy}>
        <h2 id="discover-nearby-heading">Discover Things to Do Near Tweed Heads South, NSW</h2>
        <h3>Explore the Tweed Valley, Tweed Coast &amp; Surrounding Region</h3>
        <p>
          Staying at Arabella Motor Inn means you're within easy reach of a variety of local experiences.
        </p>
        <p>
          Discover things to do in Tweed Heads South, NSW, explore the natural beauty of the Tweed Valley, visit nearby coastal towns or enjoy a day trip towards Tweed Heads and the Gold Coast.
        </p>
        <h3>Popular places to visit include:</h3>
        <ul className={styles.places}>
          {popularPlaces.map((place) => (
            <li key={place}>{place}</li>
          ))}
        </ul>
        <Link to="/experiences" className={styles.exploreLink} target="_blank" rel="noopener noreferrer">
          Explore Things to Do Near Tweed Heads South, NSW →
        </Link>
      </div>
      <img
        className={styles.photo}
        src="https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1200&q=70"
        alt="River and valley scenery near Tweed Heads South, NSW"
        onError={(event) => {
          event.currentTarget.src = "/images/ARB. 3.jpg";
        }}
      />
    </section>
  );
};

export default DiscoverNearbySection;
